import Vue from 'vue';
import Vuex, { createLogger } from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import common from './modules/common';
import home from './modules/home';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const persistedstateOptions = {
    storage: window.sessionStorage,
    key: 'yt-vuex'
};

export default new Vuex.Store({
    modules: {
        common,
        home
    },
    strict: debug,
    plugins: debug ? [createLogger(), createPersistedState(persistedstateOptions)] : [createPersistedState(persistedstateOptions)]
});



// WEBPACK FOOTER //
// ./src/store/index.js